import {Rect, Polygon, Line, Curve, Circle, FreePolygon, Text, ImageRect} from './Shapes/index.js'


class Canvas {
	canvas = null;
	ctx = null;

	shapes = {}

	constructor(id) {
		if (id instanceof HTMLCanvasElement) {
			this.canvas = id
		} else {
			this.canvas = document.getElementById(id);
		}
		if (!this.canvas) return;
		this.ctx = this.canvas.getContext("2d");
	}

	inject(shape) {
		this.shapes[shape.id] = shape
	}

	async draw() {
		for (const id in this.shapes) {
			const shape = this.shapes[id]
			if (shape instanceof ImageRect) {
				await shape.draw(this.ctx);
			} else {
				shape.draw(this.ctx);
			}
		}
	}

	download(name = 'levcharity-picture.png') {
		const image = this.canvas.toDataURL("image/png");

		const link = document.createElement("a");
		link.href = image;
		link.download = name;
		document.body.appendChild(link);

		link.click();

		document.body.removeChild(link);
	}
}

Canvas.Rect = Rect;
Canvas.Polygon = Polygon;
Canvas.Line = Line;
Canvas.Curve = Curve;
Canvas.Circle = Circle;
Canvas.FreePolygon = FreePolygon;
Canvas.Text = Text;
Canvas.ImageRect = ImageRect;

export default Canvas;
